// Vue
import Vue from 'vue'

// Dependencies
import UIkit from 'uikit'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import Multiselect from 'vue-multiselect'
import { Hooper, Slide as HooperSlide, Navigation as HooperNavigation } from 'hooper'
import VueGoodTablePlugin from 'vue-good-table'
import VueApexCharts from 'vue-apexcharts'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import VCalendar from 'v-calendar'
import Loader from './plugins/loader'
import store from './store'
import router from './router'
import App from './App.vue'

// Utils and Configs
import firebase from './config/firebase'
import globals from './config/globals'
import './config/vee-validate'
import helpers from './utils/helpers'
import filters from './utils/filters'

// Styles
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'hooper/dist/hooper.css'
import 'vue-good-table/dist/vue-good-table.css'
import './assets/styles/main.scss'

const moment = extendMoment(Moment)

Vue.use(Loader)
Vue.use(VueGoodTablePlugin)
Vue.use(VueApexCharts)
Vue.use(VCalendar)
Vue.use(filters)

UIkit.mixin({
  data: {
    timeout: 10000,
    pos: 'top-right'
  }
}, 'notification')

// eslint-disable-next-line no-restricted-globals
if (process.env.NODE_ENV === 'development' && location.hostname === 'localhost' && location.port === '5005') {
  firebase.firestore().settings({
    host: 'localhost:8080',
    ssl: false
  })
}

Vue.component('multiselect', Multiselect)
Vue.component('hooper', Hooper)
Vue.component('hooper-slide', HooperSlide)
Vue.component('hooper-navigation', HooperNavigation)
Vue.component('apexchart', VueApexCharts)

Vue.prototype.$bus = new Vue()
Vue.prototype.$globals = globals
Vue.prototype.$helpers = helpers
Vue.prototype.$firebase = firebase
Vue.prototype.$firebaseFunctions = firebase.app().functions('europe-west2')

Vue.prototype.$uikit = UIkit
Vue.prototype.$moment = moment
Vue.prototype.$parsePhone = parsePhoneNumberFromString
Vue.prototype.$icons = {
  refresh: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>'
}

Vue.prototype.$globals.iframe = window.self !== window.top

Vue.directive('debounce', (el, binding) => helpers.debounce(el, binding))

// Vue.directive('uppercase', (el, binding) => helpers.uppercase(el, binding))

Vue.config.productionTip = false

if (window.Cypress) {
  // Expose Vue errors to Cypress as uncaught exceptions
  // eslint-disable-next-line func-names
  Vue.config.errorHandler = function (err/* , vm, info */) {
    setTimeout(() => { throw err })
  }
}

firebase.auth().onAuthStateChanged((user) => {
  const loginRoute = (Vue.prototype.$globals.iframe || store.state.account.type === 'agent') ? { name: 'login', query: { type: 'agent' } } : { name: 'login' }

  if (user) {
    store.dispatch('start', user).then((result) => {
      if (!result) {
        store.commit('setError', { type: 'login', value: 'Could not read data from the server! Please contact administrator. (x400-3)' })
        router.push(loginRoute)
      } else if (store.state.account.record && store.state.account.profile && router.currentRoute.name === 'login') {
        router.push({ name: 'dashboard' })
      }
    })
  } else {
    // User does not exist (user is not logged in)
    // eslint-disable-next-line no-lonely-if
    if (router.currentRoute.name !== 'login') {
      router.push(loginRoute)
      store.dispatch('reset')
    } else {
      store.commit('setLoading', false)
    }
  }
})

router.beforeEach((to, from, next) => {
  const { auth } = to.meta
  const type = localStorage.getItem('userType')
  // Local Storage is used to prevent access after page reload, because Vuex Storage is not ready soon enough.

  // If account type is not set/defined, then the account was not loaded yet, or something went wrong
  if (type) {
    if (auth === 'all' || auth.includes(type)) next()
    else next({ name: 'error-insufficient-permissions' })
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
